/**
 * stores/index.js
 *
 * All stores are listed here.
 */
export {default as LoginStore} from './LoginStore';
export {default as LocalizationStore} from './LocalizationStore';
export {default as AppConfigStore} from './AppConfigStore';
export {default as HeaderStore} from './HeaderStore';
export {default as FooterStore} from './FooterStore';
export {default as HomeStore} from './HomeStore';
export {default as PageStore} from './PageStore';
export {default as SubscriptionStore} from './SubscriptionStore';
export {BlogStore, LocalizationStore as BlogLocalizationStore} from 'epic-minimalist-blog/app/scripts/stores';
export {default as PatchNotesStore} from './PatchNotesStore';
export {default as FaqStore} from './FaqStore';
export {default as EulaStore} from './EulaStore';
